import React from "react";
import { Link } from "react-router-dom";
import "./Mainservice.css";

const Mainservice = ({ service }) => {
  const { name, img, details } = service;
  return (
    <div className="mainservice pb-3">
      <img className="mainimg" src={img} alt="" />
      <h4>{name}</h4>
      <Link to={`/booking/${details}`}>
        <button className="btn btn-danger p-2 mt-2">Check Details</button>
      </Link>
    </div>
  );
};

export default Mainservice;
